/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type UnarchiveVehicleMutationVariables = Types.Exact<{
  input: Types.UnarchiveVehicleInput
}>

export type UnarchiveVehicleMutation = {
  __typename?: 'Mutation'
  unarchiveVehicle: {
    __typename?: 'VehicleResponse'
    success: boolean
    vehicle: {
      __typename?: 'Vehicle'
      id: string
      state: Types.VehicleState
      fleet: { __typename?: 'Fleet'; id: string; name: string } | null
      region: { __typename?: 'Region'; id: string; name: string } | null
    }
  }
}

export const UnarchiveVehicleDocument = gql`
    mutation unarchiveVehicle($input: UnarchiveVehicleInput!) {
  unarchiveVehicle(input: $input) {
    success
    vehicle {
      id
      state
      fleet {
        id
        name
      }
      region {
        id
        name
      }
    }
  }
}
    `
export type UnarchiveVehicleMutationFn = Apollo.MutationFunction<
  UnarchiveVehicleMutation,
  UnarchiveVehicleMutationVariables
>

/**
 * __useUnarchiveVehicleMutation__
 *
 * To run a mutation, you first call `useUnarchiveVehicleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnarchiveVehicleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unarchiveVehicleMutation, { data, loading, error }] = useUnarchiveVehicleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnarchiveVehicleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UnarchiveVehicleMutation,
    UnarchiveVehicleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UnarchiveVehicleMutation,
    UnarchiveVehicleMutationVariables
  >(UnarchiveVehicleDocument, options)
}
export type UnarchiveVehicleMutationHookResult = ReturnType<
  typeof useUnarchiveVehicleMutation
>
export type UnarchiveVehicleMutationResult =
  Apollo.MutationResult<UnarchiveVehicleMutation>
export type UnarchiveVehicleMutationOptions = Apollo.BaseMutationOptions<
  UnarchiveVehicleMutation,
  UnarchiveVehicleMutationVariables
>
